import { Link } from "@tanstack/react-router"

import LogoWithText from "@/components/logo-with-text"
import SVG from "@/components/svg"

const SOCIAL_LINKS = [
  {
    name: "linkedin" as const,
    href: "https://www.linkedin.com/company/wattbotdotcom",
  },
  { name: "reddit" as const, href: "https://www.reddit.com/user/WattBotBot/" },
  { name: "x" as const, href: "https://x.com/wattbotdotcom" },
]

const NAV_LINKS = [
  { label: "Methodology", href: "/methodology" },
  { label: "Privacy", href: "/privacy" },
  { label: "Terms", href: "/terms" },
]

export const SharedFooter = () => {
  return (
    <footer className="brand-dark border-t-2 p-8 md:p-12">
      <div className="flex flex-col justify-between gap-8 md:flex-row md:items-start">
        <div>
          <Link to="/">
            <LogoWithText />
          </Link>
          <p className="mt-4 max-w-xs font-mono text-xs leading-relaxed text-gray-400">
            {`WattBot is a network of America's most trusted solar installers.`}
          </p>
        </div>
        <nav className="flex flex-wrap items-center gap-x-6 gap-y-2 font-mono text-sm text-gray-300">
          {NAV_LINKS.map((link) => (
            <Link
              key={link.href}
              to={link.href}
              className="hover:text-white hover:underline"
            >
              {link.label}
            </Link>
          ))}
        </nav>
      </div>

      <div className="mt-8 flex flex-col items-start justify-between gap-4 border-t border-gray-800 pt-8 md:flex-row md:items-center">
        <div className="font-mono text-xs text-gray-500">
          {`\u00A9 ${new Date().getFullYear()} WattBot`}
        </div>
        <div className="flex gap-4">
          {SOCIAL_LINKS.map((social) => (
            <a
              key={social.name}
              href={social.href}
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-brand text-gray-500 transition-colors [&_svg]:size-5"
            >
              <SVG name={social.name} />
            </a>
          ))}
        </div>
      </div>
    </footer>
  )
}
